import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "hooks";

import { getNavigationItems } from "./navigation-items";

export function useNavigationItems() {
  const { user } = useAuth();
  const { t } = useTranslation("common", { keyPrefix: "navigation_items" });
  return useMemo(() => getNavigationItems(t, { user }), [t, user]);
}
